<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ct" id="start" style="margin-top:120px;">CHAOS</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 6-start.vue?e3904bfe